/*eslint-disable no-undef */
/*eslint-disable no-unused-vars */
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Container, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import ResultCard from './ResultCard';
import SearchFilter from './SearchFilter';
import InLineSearchFilter from './InLineSearchFilter';
import './index.scss';
import ResultsCardSkeleton from '../../skeleton/SearchResultsCard';
import CustomPagination from 'src/Member/components/common/paginationWithOffset';
import CustomPaginationItemsDisplay from 'src/Member/components/common/paginationWithOffset/CustomPaginationItemsDisplay';
import {
  setFilterChangeStatus,
  setSearchProviderParams,
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
} from 'src/redux/member/priceCompareSlice';
import DataNotFound from 'src/Member/components/common/dataNotFound/DataNotFound';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import BottomSideBar from '../../components/bottom-sidebar/BottomSideBar';
import CostBar from '../../components/cost-bar/CostBar';
import {
  getPriceComaperFilters,
  searchProvidersPC,
} from '../../../../../redux/member/api-calls/priceCompare';
import { ToastContainer } from 'react-toastify';

const displayPaginationMininumCount = 10;
const NumberOfItemsSelect = ({
  pagination,
  pageSizeHandler,
  isSuffixMessageVisible,
  dataLength,
}) => (
  <>
    {pagination?.TotalRecords > displayPaginationMininumCount ? (
      <CustomPaginationItemsDisplay
        pageSize={pagination?.PageSize}
        setPageSize={pageSizeHandler}
        prefixMessage="Records per page"
        suffixMessage={
          isSuffixMessageVisible &&
          `Showing ${
            pagination?.PageSize * (pagination?.PageNumber - 1) + 1
          } - ${
            pagination?.PageSize * (pagination?.PageNumber - 1) + dataLength
          } of ${pagination?.TotalRecords} provider results`
        }
      />
    ) : null}
  </>
);

const SearchResults = ({
  data = [],
  //pagination: {pageSize: 10, },
  isSearchingProviders,
  serachNetworksFor,
  CoveredCostComparePriceArray,
  onResetFiltersClick,
  onApplyFiltersPanelClick,
  coveredCostLoading = false,
}) => {
  console.log('data results jatin', data);
  //new custom manual pagination implementation
  const { sortby, sortdirection, selectedNetwork, pagenumber } = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams,
  );
  const [pagination, setPagination] = useState({
    PageNumber: pagenumber || 1,
    PageSize: 10,
    TotalRecords: data?.length || 0,
    MaxPageNum: Math.ceil(data?.length / 10),
  });
  const [dataToShow, setDataToShow] = useState([]);
  //const [data, setAllDataContainer] = useState([]);
  const [isSearchingProvidersLocal, setIsSearchingProvidersLocal] =
    useState(false);

  useEffect(() => {
    if (isSearchingProviders === true) {
      setSkeletonShown(true);
    }
  }, [isSearchingProviders]);

  useEffect(() => {
    setPagination({
      PageNumber: pagenumber || 1,
      PageSize: 10,
      TotalRecords: data?.length || 0,
      MaxPageNum: Math.ceil(data?.length / 10),
    });
    if (data?.length > 0) {
      console.log('********* >>>>>>>> 111111111');
      if (pagenumber > 1) {
        console.log(
          '********* >>>>>>>> 2222222222',
          (pagenumber - 1) * (pagination.PageSize || 10) + 1,
          pagenumber * (pagination.PageSize || 10),
        );
        setDataToShow(
          [...data].slice(
            (pagenumber - 1) * (pagination.PageSize || 10) + 1,
            pagenumber * (pagination.PageSize || 10),
          ),
        );
      } else {
        console.log('********* >>>>>>>> 3333333333');
        setDataToShow([...data].slice(0, pagination.PageSize || 10));
      }
    }
  }, []);

  useEffect(() => {
    //setIsSearchingProvidersLocal(true);
    if (data?.length > 0) {
      const startIndex =
        ((pagenumber || pagination.PageNumber) - 1) * pagination.PageSize;
      const endIndex =
        (pagenumber || pagination.PageNumber) * pagination.PageSize;
      const maxPageNum = Math.ceil(data?.length / pagination.PageSize);
      //setDataToShow([]);
      //setTimeout(() => {
      console.log('********** 112', startIndex, endIndex, maxPageNum);
      setDataToShow([...data].slice(startIndex, endIndex));
      //setIsSearchingProvidersLocal(false);
      //}, 0);
      setPagination({
        ...pagination,
        TotalRecords: data?.length,
        MaxPageNum: maxPageNum,
      });
    } else {
      setDataToShow([]);
      setPagination({
        PageNumber: 1,
        PageSize: 10,
        TotalRecords: 0,
        MaxPageNum: 1,
      });
      //setIsSearchingProvidersLocal(false);
    }
  }, [pagination?.PageNumber, pagination?.PageSize, data]);

  const [currentPage, setCurrentPage] = useState(pagination?.PageNumber);
  const [pageSize, setPageSize] = useState(pagination?.PageSize);
  const [searchGenderFilterClicked, setSearchGenderFilterClicked] =
    useState('');
  const [searchDistanceFilterClicked, setSearchDistanceFilterClicked] =
    useState('');
  const [searchLanguageFilterClicked, setSearchLanguageFilterClicked] =
    useState('');
  const [searchFilterBestMatchClicked, setSearchBestMatchFilterClicked] =
    useState('');
  const [accessibilityCurrentPage, setAccessibilityCurrentPage] = useState(0);
  const allFilters = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams.filters,
  );
  const { isSearchingProvidersFromResetFilters } = useSelector(
    ({ priceCompare }) => priceCompare,
  );
  const {
    providerByData: originalProviderByData,
    filters: searchParamsForUIFilters,
    typesOfSpecialtyData,
    networksData,
  } = useSelector(({ priceCompare }) => priceCompare.searchParamsForUI);

  const providerByData = searchParamsForUIFilters?.providerByData
    ? searchParamsForUIFilters?.providerByData
    : originalProviderByData;

  const isExternalProvider = networksData?.ProviderDirectory === 'R';
  const { Provider } = allFilters;
  const {
    showFilterBar,
    noResultsFound,
    showServerError,
    address,
    providerType,
    selectedCheckedItems,
    selectedCheckedRowData,
    searchProviderFiltersChanged,
  } = useSelector(({ priceCompare }) => priceCompare);
  const { DoctorByType, DoctorByName, facilityname, speciality } = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams,
  );

  const getSearchTearm = () => {
    let searchText = `${address}/`;

    if (typesOfSpecialtyData) {
      if (Provider === 'facility') {
        if (providerByData === 'facility-type') {
          searchText +=
            'Facility Type/' + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        } else {
          searchText +=
            'Facility Name or Tax ID/' + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        }
      } else {
        if (providerByData === 'doctor-type') {
          searchText +=
            'Doctor Type/' + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        } else {
          searchText +=
            "Doctor's Name or NPI/" + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        }
      }
    }
    setSearchTerm(searchText);
  };

  const [searchTerm, setSearchTerm] = useState('');
  const [skeletonShown, setSkeletonShown] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    getSearchTearm();
  }, [DoctorByType, DoctorByName, speciality, facilityname, address]);

  useEffect(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
  }, [currentPage, pageSize]);

  //useEffect(() => {
  //if (data?.length && selectedNetwork?.ProviderDirectory === 'R') {
  ////const ids = new Set(data.map(d => d?.PhysicianID));
  ////setAllDataContainer([...data, ...data?.filter(d => !ids.has(d?.PhysicianID))]);
  //setAllDataContainer([...data]);
  //} else {
  //if (selectedNetwork?.ProviderDirectory !== 'R') {
  //setAllDataContainer([]);
  //}
  //}
  //}, [data]);

  const pageSizeHandler = (pageSizeInfo) => {
    setPageSize(1);
    dispatch(setSearchProviderParams({ pagenumber: 1 }));
    dispatch(setSearchProviderParams({ pagesize: pageSizeInfo.value }));
    dispatch(setFilterChangeStatus(true));
  };

  const pageChangeHandler = (pageNum) => {
    dispatch(setSearchProviderParams({ pagenumber: pageNum }));
    setPagination({ ...pagination, PageNumber: pageNum });
    //dispatch(setFilterChangeStatus(true));
    if (pageNum === pagination.MaxPageNum) {
      dispatch(searchProvidersPC({ pagenumber: data?.length + 1 }));
    }
  };
  const onChangeGenderEvent = (val) => {
    setSearchGenderFilterClicked(val);
  };
  const onChangeDistanceEvent = (val) => {
    setSearchDistanceFilterClicked(val);
  };
  const onChangeLanguageEvent = (val) => {
    setSearchLanguageFilterClicked(val);
  };
  const onChangeBestMatchEvent = (val) => {
    setSearchBestMatchFilterClicked(val);
  };
  useEffect(() => {
    if (searchProviderFiltersChanged === true) {
      //dispatch(setFilterChangeStatus(false));
      //dispatch(searchProvidersPC());
      //dispatch(getPriceComaperFilters());
    }
  }, [searchProviderFiltersChanged]);
  return (
    <>
      <Container>
        <SearchFilter isFromCignaRoaster={true} />
      </Container>

      {/*In line filter */}
      {showFilterBar && (
        <div className="provider-search-filter-container mt-4 mt-md-5 mb-0">
          <Container role="In line search">
            <InLineSearchFilter
              isFromCignaRoaster={true}
              onChangeGenderEvent={(val) => onChangeGenderEvent(val)}
              onChangeDistanceEvent={(val) => onChangeDistanceEvent(val)}
              onChangeLanguageEvent={(val) => onChangeLanguageEvent(val)}
              onChangeBestMatchEvent={(val) => onChangeBestMatchEvent(val)}
              searchFilterBestMatchClicked={searchFilterBestMatchClicked}
              searchGenderFilterClicked={searchGenderFilterClicked}
              searchDistanceFilterClicked={searchDistanceFilterClicked}
              searchLanguageFilterClicked={searchLanguageFilterClicked}
              onResetFiltersClick={onResetFiltersClick}
              onApplyFiltersPanelClick={onApplyFiltersPanelClick}
            />
          </Container>
        </div>
      )}

      {/*cost bar */}
      {/*<Container role="cost bar" className="cost-bar">
        <CostBar />
      </Container> */}

      <Container
        className="p-0 price-compare-results-container"
        role="table"
        aria-label="Compare Price Results"
        aria-describedby="search_results_price_compare"
      >
        {/*{!isSearchingProviders && data && data?.length > 0 && ( */}
        {data?.length > 0 && (
          <>
            <div
              id="search_results_price_compare"
              className="sr-only"
              aria-hidden={true}
            >
              Compare Price for Provider Results
            </div>
            {pagination && !isSearchingProvidersFromResetFilters && (
              <Row className="my-4">
                <Col md={7} className="display-pagination">
                  {/*<NumberOfItemsSelect
                    pagination={pagination}
                    dataLength={data?.length || 0}
                    pageSizeHandler={pageSizeHandler}
                    isSuffixMessageVisible
                  /> */}
                </Col>
                {pagination?.TotalRecords > displayPaginationMininumCount ? (
                  <Col md={5} className="display-pagination">
                    <CustomPagination
                      className="pagination-bar justify-content-end find-doctor-pagination"
                      currentPage={pagenumber || pagination?.PageNumber}
                      totalCount={pagination?.TotalRecords}
                      siblingCount={1}
                      pageSize={pagination?.PageSize}
                      onPageChange={(page) => {
                        pageChangeHandler(page);
                      }}
                      accessibilityPagination={true}
                      accessibilityCurrentPage={accessibilityCurrentPage}
                      setAccessibilityCurrentPage={setAccessibilityCurrentPage}
                    />
                  </Col>
                ) : null}
              </Row>
            )}
            {/*{isSearchingProvidersLocal ? ( */}
            {isSearchingProvidersFromResetFilters ? (
              <div className="mt-5">
                {[0, 1, 2].map((ele, i) => {
                  return (
                    <Fragment key={i}>
                      <ResultsCardSkeleton />
                    </Fragment>
                  );
                })}
              </div>
            ) : (
              dataToShow &&
              dataToShow.map((ele, i) => {
                return (
                  <Fragment
                    key={ele.PhysicianID ? ele.PhysicianID : ele.FacilityID}
                  >
                    <ResultCard
                      //elemkey={`${ele.PhysicianID}${i}`}
                      data={ele}
                      isAccordion={true}
                      setSelectedCheckedItems={setSelectedCheckedItems}
                      selectedCheckedItems={selectedCheckedItems}
                      setSelectedCheckedRowData={setSelectedCheckedRowData}
                      selectedCheckedRowData={selectedCheckedRowData}
                      serachNetworksFor={serachNetworksFor}
                      CoveredCostComparePriceArray={
                        CoveredCostComparePriceArray
                      }
                      isExternalProvider={isExternalProvider}
                      coveredCostLoading={coveredCostLoading}
                    />
                  </Fragment>
                );
              })
            )}

            {pagination && !isSearchingProvidersFromResetFilters && (
              <Row className="my-4">
                <Col md={7}>
                  {/*<NumberOfItemsSelect
                    pagination={pagination}
                    dataLength={data?.length || 0}
                    pageSizeHandler={pageSizeHandler}
                    isSuffixMessageVisible
                  /> */}
                </Col>
                {pagination?.TotalRecords > displayPaginationMininumCount ? (
                  <Col md={5}>
                    <CustomPagination
                      className="pagination-bar justify-content-end"
                      currentPage={pagenumber || pagination?.PageNumber}
                      totalCount={pagination?.TotalRecords}
                      siblingCount={1}
                      pageSize={pagination?.PageSize}
                      onPageChange={(page) => {
                        pageChangeHandler(page);
                      }}
                      accessibilityPagination={true}
                      accessibilityCurrentPage={accessibilityCurrentPage}
                      setAccessibilityCurrentPage={setAccessibilityCurrentPage}
                    />
                  </Col>
                ) : null}
              </Row>
            )}
          </>
        )}

        {isSearchingProvidersFromResetFilters && (
          <div className="mt-5">
            {[0, 1, 2].map((ele, i) => {
              return (
                <Fragment key={i}>
                  <ResultsCardSkeleton />
                </Fragment>
              );
            })}
          </div>
        )}

        {(noResultsFound || (!isSearchingProviders && data?.length === 0)) && (
          <DataNotFound searchText={searchTerm} />
        )}
      </Container>
      <Container>
        {showServerError && (
          <CustomClientError
            ErrorHeading="Something went wrong with the request!"
            ErrorMessage="Please try again."
            CustomClasses="p-0 m-0"
          />
        )}
      </Container>
      <BottomSideBar
        selectedCheckedItems={selectedCheckedItems}
        selectedCheckedRowData={selectedCheckedRowData}
      ></BottomSideBar>

      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

export default SearchResults;
